import { Action } from 'redux';
import { ProducerStateStructure } from '../interfaces/producerStateStructure.interface';
import { BaseAgency, SeniorAgency } from '@ptl/account-management';
import { OtherUserInfo } from '../interfaces/otherUserInfo.interface';
import { AgentInfo } from '../../../../shared/interfaces/application-retrieval/agentInfo.interface';

export const PRODUCER_STATE_NAME = 'Producer';
const INITIAL_STATE: ProducerStateStructure = {
  selectedAgency: {
    agencyId: '',
    agentACSId: '',
    agencyName: '',
    agencyPartyId: '',
    region: null,
    countyPreference: '',
    entitlements: [],
    agentPartyId: '',
    npnNo: ''
  },
  otherUserInfo: {
    isOnCallWithFieldAgent: false
  }
};

const SAVE_AGENCY = 'SAVE_AGENCY';
const SAVE_OTHER_USER_INFO = 'SAVE_OTHER_USER_INFO';
const INIT_AGENCY = 'INIT_AGENCY';
const PERSIST_PRODUCER = 'PERSIST_PRODUCER';
const SAVE_AGENCY_FROM_ENROLLMENT = 'SAVE_AGENCY_FROM_ENROLLMENT';

export class ProducerAppAction implements Action {
  type: string;
  selectedAgency?: BaseAgency;
  otherUserInfo?: OtherUserInfo;
  producer?: ProducerStateStructure;
  agentInfo?: AgentInfo;
}

export function saveAgency(agency: BaseAgency): ProducerAppAction {
  return {
    type: SAVE_AGENCY,
    selectedAgency : agency
  };
}

export function saveOtherUserInfo(otherUserInformation: OtherUserInfo): ProducerAppAction {
  return {
    type: SAVE_OTHER_USER_INFO,
    otherUserInfo : otherUserInformation
  };
}

export function persistProducer(producerData: ProducerStateStructure): ProducerAppAction {
  return {
    type: SAVE_AGENCY,
    producer : producerData
  };
}

export function loadExistingAgencyIntoState(agentInfo: AgentInfo): ProducerAppAction {
  return {
    type: SAVE_AGENCY_FROM_ENROLLMENT,
    agentInfo
  };
}
/**
 * Login info reducers
 */
export function Producer( state: ProducerStateStructure = INITIAL_STATE, action: ProducerAppAction ) {
  const copiedState = JSON.parse(JSON.stringify(Object.assign({}, state)));
  switch (action.type) {
    case SAVE_AGENCY:
      copiedState.selectedAgency = action.selectedAgency;
      return Object.assign({}, state, copiedState);
    case SAVE_OTHER_USER_INFO:
      copiedState.otherUserInfo = action.otherUserInfo;
      return Object.assign({}, state, copiedState);
    case INIT_AGENCY:
    case PERSIST_PRODUCER:
      return Object.assign({}, state, action.producer);
    case SAVE_AGENCY_FROM_ENROLLMENT:
      copiedState.selectedAgency = {};
      copiedState.selectedAgency.agencyId = action.agentInfo.agencyId;
      copiedState.selectedAgency.agencyName = action.agentInfo.agencyName;
      copiedState.selectedAgency.npnNo = action.agentInfo.npnNumber;
      return Object.assign({}, state, copiedState);
    default:
      return state;
  }
}
